import * as s from 'styled-components';
const styled = s.default;

export const H1: any = styled.h1`
  color: ${({ theme }) => theme.secondaryFontColor};
  font-size: ${({ theme }) => theme.fontSizeL};
  font-family: ${({ theme }) => theme.secondaryFont};
`;
